module.exports = __webpack_public_path__ + "static/media/wevo_logo_wide_color.b20f916e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/wevo_logo_wide_color.svg
// module id = 1613
// module chunks = 0